/* eslint-disable @next/next/no-img-element */
'use client'

import { useCallback, useState } from 'react'

/**
 * The Dabba discount nudge in the corner of the home page.
 *
 * Whether it shows at all is decided by the caller from the hero cat's traits,
 * so this no longer reaches into the auction manager for the current cat.
 */
export default function FloatingDabbaButton() {
  const [isHovered, setIsHovered] = useState(false)

  const handleClick = useCallback(() => {
    window.open('https://dabba.com/dewicats', '_blank')
  }, [])

  return (
    <button
      className={`fixed bottom-4 right-4 z-50 rounded-full bg-dark-8 border-[#ffd903] border-2 text-white shadow-lg transition-all duration-300 ease-in-out ${
        isHovered ? 'w-auto max-w-[calc(100%-2rem)] px-4' : 'w-28'
      } h-16 flex items-center justify-center overflow-hidden`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
      aria-label="DeWiCats Dabba discounts"
    >
      <span
        className={`whitespace-normal ${isHovered ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300 flex-row flex items-center gap-2`}
      >
        <img
          src="/assets/dabbaLogo.jpg"
          alt="DeWiCats"
          className="w-10 h-10 rounded-full"
        />
        Pspsps... DeWiCats, follow me to your Dabba discounts 🐱
      </span>
      <span
        className={`absolute ${isHovered ? 'opacity-0' : 'opacity-100'} transition-opacity duration-300`}
      >
        pspsps...🐱
      </span>
    </button>
  )
}
